import React from "react";
import { Route, Redirect } from "react-router-dom";

// Helper Functions
import { isAuthenticated } from "utils/helperFunctions";

export function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        return isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        );
      }}
    />
  );
}
export function PublicRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />;
        // return isAuthenticated()
        //   ?
        //   <Redirect to='/' />
        //   :
      }}
    />
  );
}
